import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { ErrorCard, StyledPage } from "@src/components";

const RouteErrorPage = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error("Router error::", error);
  }, [error]);

  return (
    <StyledPage>
      <ErrorCard
        title="Sorry, something went wrong."
        subtitle="Please continue via the main menu in the header."
      />
    </StyledPage>
  );
};

export { RouteErrorPage };
